'use es6';

import { createSelector } from 'reselect';

const pickListingsSlugs = listings => listings.map(listing => listing.slug);

export const getCollectionsRequestState = state => state.collections.requestState;
export const getCollectionListings = state => state.collections.listings;
export const getDisplayedCollectionListings = createSelector([getCollectionListings], listings => listings.filter(listing => !!listing.displayed));
export const getTotalDisplayedCollectionListings = createSelector([getDisplayedCollectionListings], listings => listings.size);
export const getCollectionSlugs = createSelector([getCollectionListings], pickListingsSlugs);
export const makeGetCollectionListingBySlug = () => createSelector([getCollectionListings, (__state, {
  slug
}) => slug], (listings, slug) => listings.find(listing => listing.slug === slug));
export const makeGetCollectionListingById = () => createSelector([getCollectionListings, (__state, {
  collectionId
}) => collectionId], (listings, collectionId) => listings.find(listing => `${listing.collectionId}` === `${collectionId}`));